// eslint-disable-next-line prefer-destructuring, no-undef
const { location, title } = document
// eslint-disable-next-line prefer-destructuring
const { pathname } = location
const titleDocument = title

const phasedLogin = {
    funnel_step: {
        select_platform: {
            event: 'funnel_step',
            funnel: {
                name: 'login_faseado',
                current_step: 'Seleção de plataforma',
                previous_step: undefined,
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
        },
        insert_cpf: {
            event: 'funnel_step',
            funnel: {
                name: 'login_faseado',
                current_step: 'Insira o CPF',
                previous_step: undefined,
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
        },
        insert_password: {
            event: 'funnel_step',
            funnel: {
                name: 'login_faseado',
                current_step: 'Login CPF',
                previous_step: undefined,
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
        },
        insert_cip: {
            event: 'funnel_step',
            funnel: {
                name: 'login_faseado',
                current_step: 'Login CIP',
                previous_step: 'Modal de aviso CIP',
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
        },
        warning_mode: {
            event: 'funnel_step',
            funnel: {
                name: 'login_faseado',
                current_step: 'Modal de aviso CIP',
                previous_step: 'Insira o CPF',
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
        },
        login_failure: {
            event: 'login_failure',
            funnel: {
                name: 'login_faseado',
                current_step: 'Login CIP',
                previous_step: 'Insira o CPF',
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
            error: {
                message: 'Unauthenticated Client',
            },
        },
        login_failure_cpf: {
            event: 'login_failure',
            funnel: {
                name: 'login_faseado',
                current_step: 'Login CPF',
                previous_step: 'Insira o CPF',
            },
            page: {
                path: pathname,
                title: titleDocument,
            },
            error: {
                message: 'Unauthenticated Client',
            },
        },
    },
}

export const analytics = {
    phasedLogin,
}
